// extracted by mini-css-extract-plugin
export var news = "styles-module--news--1UyU-";
export var news_txt_title = "styles-module--news_txt_title--2WFXn";
export var news_image_inner = "styles-module--news_image_inner--2kezI";
export var news_image = "styles-module--news_image--3Pvkc";
export var news_txt = "styles-module--news_txt--47Qu9";
export var news_txt_date = "styles-module--news_txt_date--e6A3f";